import React from 'react';
import { IConversationOrderData } from '../../types/conversations/IConversation';
import { BoldBodyText, Header3Text, Grid, Button } from 'ui-toolkit/index';
import { SaveConversationStatusModal } from 'components/conversations/SaveConversationStatusModal';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { EditConversationContainer } from './EditConversationContainer';
import { IFetchStatus } from 'types/rest/IFetchStatus';

const EditConversationDrawerContentsLayout = styled(Grid)`
  padding: ${(props) => props.theme.spacing.spacing5};
  margin: ${(props) => props.theme.spacing.spacing5};
  gap: ${(props) => props.theme.spacing.spacing5};
  position: sticky;
  top: 100px;
`;

interface IEditConversationDrawerContentProps {
  conversationOrder?: IConversationOrderData;
  onSubmit: (values: IConversationOrderData) => void;
  fetchStatus: IFetchStatus;
  fetchError?: Error;
  closeModal: () => void;
  closeDrawer: () => void;
  autoSave: boolean;
}

const CloseConversationFormButton = styled(Button)`
  position: absolute;
  ${(props) => props.theme.fonts.header3Size};
  top: 0;
  right: 0;
`;

export const EditConversationDrawerContents: React.FC<IEditConversationDrawerContentProps> = ({
  conversationOrder,
  fetchStatus,
  fetchError,
  onSubmit,
  closeModal,
  closeDrawer,
  autoSave,
}) => (
  <EditConversationDrawerContentsLayout>
    <CloseConversationFormButton type="button" intent={'ghost'} onClick={closeDrawer}>
      <FontAwesomeIcon icon={faTimes} />
    </CloseConversationFormButton>
    <Grid>
      <Header3Text>Link this call to an order</Header3Text>
      <BoldBodyText>Only a File Number is required</BoldBodyText>
    </Grid>

    <div>
      {conversationOrder && conversationOrder.genesysId && (
        <>
          <EditConversationContainer
            conversationId={conversationOrder.genesysId}
            onSubmit={onSubmit}
            saveButtonText={'Save and Close'}
            autoSave={autoSave}
          />
        </>
      )}
    </div>
    {fetchStatus.fetched && (
      <SaveConversationStatusModal fetchStatus={fetchStatus} fetchError={fetchError} close={closeModal} />
    )}
  </EditConversationDrawerContentsLayout>
);
